var $5afe469a63fcac7b$exports = {};
$5afe469a63fcac7b$exports = {
  "ascending": "vzostupne",
  "ascendingSort": function ascendingSort(args) {
    return "zoraden\xE9 zostupne pod\u013Ea st\u013Apca ".concat(args.columnName);
  },
  "columnSize": function columnSize(args) {
    return "Po\u010Det pixelov: ".concat(args.value);
  },
  "descending": "zostupne",
  "descendingSort": function descendingSort(args) {
    return "zoraden\xE9 zostupne pod\u013Ea st\u013Apca ".concat(args.columnName);
  },
  "resizerDescription": "Stla\u010Den\xEDm kl\xE1vesu Enter za\u010Dnete zmenu ve\u013Ekosti",
  "select": "Vybra\u0165",
  "selectAll": "Vybra\u0165 v\u0161etko",
  "sortable": "zoradite\u013En\xFD st\u013Apec"
};
export { $5afe469a63fcac7b$exports as default };